import { Link } from 'react-router-dom';
import { comics } from '@/mocks/comics';

export default function LatestUpdates() {
  const latest = [...comics]
    .sort((a, b) => new Date(b.updatedAt).getTime() - new Date(a.updatedAt).getTime())
    .slice(0, 6);

  return (
    <section className="py-10 md:py-14 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <div className="flex items-center justify-between mb-6 md:mb-8">
          <div>
            <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
              <i className="ri-time-line text-accent-500 mr-2"></i>
              最近更新
            </h2>
            <p className="text-sm text-foreground-500 mt-1">实时追踪最新韩漫更新动态</p>
          </div>
          <Link
            to="/category/all"
            className="text-sm text-accent-600 hover:text-accent-700 font-medium flex items-center gap-1 whitespace-nowrap cursor-pointer"
          >
            更多更新 <i className="ri-arrow-right-line"></i>
          </Link>
        </div>

        <div className="space-y-3">
          {latest.map((comic) => (
            <Link
              key={comic.id}
              to={`/comic/${comic.id}`}
              className="flex items-center gap-4 p-3 md:p-4 bg-background-50 rounded-lg hover:bg-background-100 transition-colors cursor-pointer group"
            >
              <div className="w-14 h-14 md:w-16 md:h-16 rounded-lg overflow-hidden flex-shrink-0">
                <img
                  src={comic.cover}
                  alt={comic.title}
                  className="w-full h-full object-cover object-top"
                />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-sm font-semibold text-foreground-950 group-hover:text-primary-600 transition-colors line-clamp-1">
                  {comic.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-1 line-clamp-1">
                  {comic.description}
                </p>
                <div className="flex items-center gap-3 mt-1.5">
                  <span className="text-xs text-foreground-400">{comic.author}</span>
                  <span className="text-xs text-primary-500 font-medium">
                    更新至第{comic.chapters.length}话
                  </span>
                </div>
              </div>
              <div className="text-right flex-shrink-0">
                <span className="text-xs text-foreground-400">{comic.updatedAt}</span>
                <div className="flex items-center gap-1 justify-end mt-1">
                  <i className="ri-star-fill text-accent-400 text-xs"></i>
                  <span className="text-xs font-medium text-foreground-700">{comic.rating}</span>
                </div>
              </div>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}